import CoreBase from '../../../../services/engines/CoreBase';
import logService from '../../../../services/wss/logService3';
import groupNodeCache from '../Engines/GroupNodeCache';

const _name = 'OnGroupNodesLoadedHandler';

/**
 * Handles the OnGroupNodesLoaded SignalR event.
 * Fills the cache with the nodes and entries provided by BE.
 * Only dependency is GroupNodeCache — fully testable in isolation.
 */
export default class OnGroupNodesLoadedHandler extends CoreBase {
    handle = (data) => {
        try {
            if (!data?.gid) {
                return false;
            }

            groupNodeCache.clear();

            data.nodes.forEach((n) => {
                const node = {
                    key: n.key,
                    label: n.label,
                    entries: n.entries,
                    total: n.total,
                    page: n.page,
                };
                groupNodeCache.setNode(n.key, node);
            });

            return true;
        } catch (error) {
            logService.logError(`${_name}.handle: ${error.message}`);
            return false;
        }
    };
}
